import { Button } from 'react-bootstrap';
import * as React from 'react';
import { MTAButtons } from '../../../MTAButtons';
import { push } from 'react-router-redux';
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

interface IObjectionHandlingProps {
  policyId: string;
  handleNext: () => any;
  actions: {
    push(path: string);
  }
}

const ObjectionHandling = ({ policyId, handleNext, actions, ...props }: IObjectionHandlingProps) => {

  const handleNextButton = () => {
    handleNext()
  }

  const renewalId = get(props, 'match.params.id', null);

  const handleBackButton = () => {

    if (renewalId) {
      actions.push(`/account/renewals/${renewalId}`)
      return;
    }

    if (policyId) {
      actions.push(`/account/make-a-change/selection/${policyId}`);
      return;
    }
    actions.push(`/account/summary`)
  }

  const continueButton = (
    <Button
      id="continue"
      type="button"
      bsStyle="primary"
      onClick={handleNextButton}
      className="secondary-button pull-left medium-width"
    >
      YES
    </Button>
  );

  const backButton = (
    <Button
      id="back"
      bsStyle="primary"
      type="button"
      className="secondary-button pull-right medium-width"
      onClick={handleBackButton}
    >NO</Button>
  )

  return (
    <>
      <MTAButtons
        button1={continueButton}
        button2={backButton}
        cancellation={true}
      />
    </>
  )
}

export default flow([
  connect(null,
    (dispatch) => ({
      dispatch,
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
  withRouter,
])(ObjectionHandling);
